import classNames from "classnames";

const LoadingPlaceholder = ({ heightClass }: { heightClass?: string }) => (
  <div
    className={classNames(
      heightClass,
      "m-auto h-32 w-full animate-pulse rounded-lg bg-gray-300 delay-75 duration-1000 sm:h-52",
    )}
  />
);

export default LoadingPlaceholder;
